import {createActionGroup, emptyProps} from '@ngrx/store';
import {ListData} from '@store/common/common.types';
import {ACCOUNT_FEATURE_KEY, MakeAPaymentValue, PatronBalanceTransaction, SquareAppDetails} from '@store/account/account.types';

export const AccountActions = createActionGroup({
  source: ACCOUNT_FEATURE_KEY,
  events: {
    'Load Balance Transactions': emptyProps(),
    'Load Balance Transactions Success': (listData: ListData<PatronBalanceTransaction>) => ({listData}),
    'Load Balance Transactions Failure': (error: unknown) => ({error}),
    'Toggle Include All Balance Transactions': emptyProps(),

    'Load Square App Details': emptyProps(),
    'Load Square App Details Success': (squareAppDetails: SquareAppDetails) => ({squareAppDetails}),
    'Load Square App Details Failure': (error: unknown) => ({error}),
    'Show Make A Payment': emptyProps(),
    'Submit Make A Payment': (value: MakeAPaymentValue) => ({value}),
    'Submit Make A Payment Success': emptyProps(),
    'Submit Make A Payment Failure': (error: unknown) => ({error}),
    'Show Payment Confirmation': (value: MakeAPaymentValue) => ({value}),
  }
});
